module.exports = __webpack_public_path__ + "img/brunei.6b4ad8ef.svg";